import FamilyPage from '@/pages/FamilyPage.vue'
import ROUTE_NAMES from '@/constants/routeNames'
import { TIDIO_STYLES } from '@/constants/tidio'

export default {
  path: '/rodzina/:familyEditionId/:warehouseId',
  props: true,
  name: ROUTE_NAMES.FAMILY,
  component: FamilyPage,
  meta: {
    title: 'Wybór Rodziny - opis Rodziny - Szlachetna Paczka',
    tidioCustomPositionStyles: TIDIO_STYLES.FIRST_VARIANT,
    metaTags: [
      {
        name: 'robots',
        content: 'noindex, follow'
      }
    ]
  },
  query: {
    context: true
  }
}
